import {
  countryCodeFound,
  getCountryNameByCode,
  getCountryObjectByCode,
  appendMapTooltip,
  modMap,
  modMapColorBorder,
  markerStyle,
  regionStyle,
  getSpanishCountryName,
} from "./helper";

jQuery(function ($) {
  if ($(".page-node-type-region").length > 0) {
    console.log("region-detail-map Ready");

    const pageLang = $("#langcode").data("langcode");
    $("#langcode").remove();

    var theMap = $("#region-map");

    const tip = $(".map-tooltip");
    const markerOverlay = theMap.next();

    const countriesData = theMap.data("json");
    const officesData = theMap.data("officemarkers");

    // Iterate through the officesData array and update styles based on category
    officesData.forEach(marker => {
      if (marker.category === "IOCBP") {
        marker.style = { fill: "#36A0E7", stroke: "white", "stroke-width": 5, r: 10 };
      } else {
        marker.style = { fill: "#F38336", stroke: "white", "stroke-width": 5, r: 10 };
      }
    });

    const zoomCountries = theMap.data("zoomcountries");
    const NawaPageUrl = theMap.data("nawa-page");
    const SsaPageUrl = theMap.data("ssa-page");

    let timeoutVar;

    let specialZoom = false;

    if (zoomCountries.x !== undefined) {
      specialZoom = {
        x: zoomCountries.x,
        y: zoomCountries.y,
        scale: zoomCountries.scale,
      };
    }

    theMap.vectorMap({
      map: "world_mill",
      backgroundColor: "#F9F9FB",
      panOnDrag: true,
      zoomAnimate: true,
      zoomOnScroll: false,
      // focusOn: {region: countryCodes},
      markers: officesData,
      markerStyle: markerStyle,
      regionStyle: regionStyle,
      onRegionClick: function (e, code) {
        const countryObj = getCountryObjectByCode(countriesData, code);

        window.location = countryObj.permalink;
      },
      onRegionOver: function (e, code) {
        e.preventDefault();

        if (countryCodeFound(countriesData, code)) {
          const countryName = getCountryNameByCode(countriesData, code);

          let content = {};

          if (pageLang === "es") {
            let esName = getSpanishCountryName(code);
            if (esName === "") {
              esName = countryName;
            }

            content.title = "<strong>" + esName + "</strong>";
            content.footer = "(Haz clic para ver la página del país)";
          } else {
            content.title = "<strong>" + countryName + "</strong>";
            content.footer = "(Click to view country page)";
          }

          appendMapTooltip(tip, content);

          tip.css("position", "fixed");
          $(".map-tooltip-close").hide();
          tip.show();

          e.target.addEventListener("mousemove", tooltipMousemove);
        }
      },
      onRegionOut: function (e, code) {
        e.preventDefault();
        const tip = $(".map-tooltip");

        tip.hide();

        e.target.removeEventListener("mousemove", tooltipMousemove);
      },
      onRegionTipShow: function (e) {
        e.preventDefault();
        return false;
      },
      onViewportChange: function (e, scale) {
        e.preventDefault();
      },
      onMarkerTipShow: function (e, o, s) {
        e.preventDefault();
      },
      onMarkerClick: function (e, index) {
        e.preventDefault();
      },
      onMarkerOver: function (e, index) {
        e.preventDefault();

        let markerData = officesData;
        let content = {};

        content.title = `${markerData[index].name} office`;
        content.subtitle = markerData[index].region_name;
        content.body = [];

        var markerElement = theMap.find("circle[data-index=" + index + "]");
        var rect = markerElement[0].getBoundingClientRect();
        var x = rect.left + window.pageXOffset;
        var y = rect.top + window.pageYOffset;

        appendMapTooltip(tip, content);

        tip.css("top", y + "px");
        tip.css("left", x + rect.width / 2 + "px");

        tip.css("position", "absolute");
        tip.show();
      },
      onMarkerOut: function (e, s) {
        e.preventDefault();
        tip.hide();
      },
    });

    function tooltipMousemove(e) {
      let top = window.pageYOffset || document.documentElement.scrollTop;
      const tip = $(".map-tooltip");

      tip.css("top", e.pageY - top + "px");
      tip.css("left", e.pageX + "px");
    }

    markerOverlay.on("click", function () {
      $(this).fadeOut();
      tip.hide();
    });

    var myMap = theMap.vectorMap("get", "mapObject");

    let countryCodes = [];

    const validCountryCodes = countriesData.filter((country, index) => {
      return myMap.regions[country.country_code] !== undefined;
    });

    // console.log('validCountryCodes', validCountryCodes);

    validCountryCodes.map((country, index) => {
      myMap.regions[country.country_code].element.config.style.selected.fill =
        "#004587";
      myMap.setSelectedRegions(country.country_code);
      countryCodes.push(country.country_code);
      theMap
        .find('path[data-code="' + country.country_code + '"]')
        .addClass("selected");
    });

    if (zoomCountries !== "") {
      if (specialZoom === false) {
        myMap.setFocus({ regions: zoomCountries });
      } else {
        var clonedObject = Object.assign({}, specialZoom);
        myMap.setFocus(clonedObject);
      }
    }

    modMap(theMap);
    modMapColorBorder(theMap);

    $(window).on("resize", function () {
      const ww = $(window).width();

      clearTimeout(timeoutVar);

      timeoutVar = setTimeout(() => {
        if (zoomCountries !== "") {
          if (specialZoom === false) {
            myMap.setFocus({ regions: zoomCountries });
          } else {
            var clonedObject = Object.assign({}, specialZoom);
            myMap.setFocus(clonedObject);
            // console.log('specialZoom post resize zoom', specialZoom);
          }
        }
      }, 100);
    });

    // Close tooltip button
    $(".map-tooltip-close").on("click", function () {
      // myMap.clearSelectedRegions();
      markerOverlay.fadeOut();
      tip.hide();
    });
  }
});
